import { render, staticRenderFns } from "./GrupoDeInteres.vue?vue&type=template&id=3751e030&"
import script from "./GrupoDeInteres.vue?vue&type=script&lang=ts&"
export * from "./GrupoDeInteres.vue?vue&type=script&lang=ts&"
import style0 from "./GrupoDeInteres.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports